import type { ActorData, ActorEventData, TSettings } from '@/types/common';
import api from '@/utils/api';

export const getSettings = ({
	client_secret
}: {
	client_secret: string;
}): Promise<TSettings> => {
	return api.get('talking-head/chat-settings', {
		client_secret
	});
};

export const getCreateActor = (data: ActorData) => {
	return api.post('talking-head/get-create-actor', data);
};

export const sendActorEvent = (data: ActorEventData) => {
	return api.post('talking-head/send-actor-event', data);
};
